import { c as _c } from "react/compiler-runtime";
import { Check } from "@icon-park/svg";
import { Icon } from "@justhome/react-ui";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
export interface ProcessStepProps {
  label: string;
  completed: boolean;
  selected: boolean;
  index: number;
  onPreviousStep: VoidFunction;
}
const ProcessStep: FC<ProcessStepProps> = t0 => {
  const $ = _c(31);
  const {
    completed,
    label,
    selected,
    index,
    onPreviousStep
  } = t0;
  const t1 = !selected;
  const t2 = !(completed || selected);
  let t3;
  if ($[0] !== selected || $[1] !== t1 || $[2] !== t2) {
    t3 = clsx("text-body-1", {
      "text-neutral-675": t1,
      "text-primary-800": selected,
      "opacity-60": t2
    });
    $[0] = selected;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== completed || $[5] !== index || $[6] !== selected) {
    t4 = index > 0 && <div className={clsx("h-m w-3s my-xs flex justify-center")}><div className={clsx("w-[2px]", {
        "bg-neutral-675": !(selected || completed),
        "bg-primary-800": selected || completed
      })} /></div>;
    $[4] = completed;
    $[5] = index;
    $[6] = selected;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !completed;
  let t6;
  if ($[8] !== onPreviousStep) {
    t6 = () => onPreviousStep();
    $[8] = onPreviousStep;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = completed || selected;
  const t8 = !(completed || selected);
  let t9;
  if ($[10] !== completed || $[11] !== t7 || $[12] !== t8) {
    t9 = clsx("flex-none text-neutral-0 border-[2px] rounded-full flex justify-center items-center h-3s w-3s", {
      "bg-primary-800": completed,
      "border-primary-800": t7,
      "border-neutral-675": t8
    });
    $[10] = completed;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== selected) {
    t10 = selected && <div className="w-3xs h-3xs rounded-full bg-primary-800 flex-none" />;
    $[14] = selected;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== completed) {
    t11 = completed && <Icon icon={Check} size="14" strokeWidth={8} className="text-neutral-0" />;
    $[16] = completed;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t9) {
    t12 = <div className={t9}>{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== label || $[23] !== t12 || $[24] !== t5 || $[25] !== t6) {
    t13 = <button disabled={t5} onClick={t6} className="flex gap-3xs items-center">{t12}{label}</button>;
    $[22] = label;
    $[23] = t12;
    $[24] = t5;
    $[25] = t6;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t3 || $[29] !== t4) {
    t14 = <li role="none" className={t3}>{t4}{t13}</li>;
    $[27] = t13;
    $[28] = t3;
    $[29] = t4;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
export interface ProcessStepsProps extends PropsWithChildren {
  className?: string;
}
const ProcessSteps: FC<ProcessStepsProps> = t0 => {
  const $ = _c(3);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className) {
    t1 = <ul className={className}>{children}</ul>;
    $[0] = children;
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Object.assign(ProcessSteps, {
  Step: ProcessStep
});